import { map as Rmap } from "ramda";
import { TruckLoad, buildNewTruckLoad } from "@/models/TruckLoad";

interface TruckLoadState {
  truckLoads: TruckLoad[];
  truckLoad: TruckLoad;
}

const state: TruckLoadState = {
  truckLoads: [],
  truckLoad: buildNewTruckLoad(),
};

const mutations = {
  LOAD_TRUCK_LOADS(state: TruckLoadState, payload: TruckLoad[]) {
    state.truckLoads = payload;
  },
  LOAD_TRUCK_LOAD(state: TruckLoadState, payload: TruckLoad) {
    state.truckLoad = payload;
  },
};

const actions = {
  loadTruckLoads(context: any, truckLoads: TruckLoad[]) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_TRUCK_LOADS", truckLoads);
      resolve(truckLoads);
    });
  },

  loadTruckLoad(context: any, truckLoad: TruckLoad) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_TRUCK_LOAD", truckLoad);
      resolve(truckLoad);
    });
  },
};

const getters = {
  truckLoads: (state: TruckLoadState) => {
    return state.truckLoads;
  },

  truckLoad: (state: TruckLoadState) => {
    return state.truckLoad;
  },
  truckLoadsForAutocompleteId: (state: TruckLoadState) => {
    // map over the items and just return a label and an id
    return Rmap(truckLoad => {
      return {
        id: truckLoad.id,
        label: truckLoad.name,
      };
    }, state.truckLoads);
  },
};

const truckLoadsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default truckLoadsModule;
